import React from 'react';

const defaultContext = {
    components: null,
    setComponent: (component: any) => { },
    removeComponent: (component: any) => { },
    lockDesigner: (locked: boolean) => { }
}

export const EditorContext = React.createContext(defaultContext);